export default {
    initialized: false,
    wsHost: "",
    excelId: "{C3052A38-C44F-4AEC-8E72-03E2F656A8A9}",
    productsSheet: "Products",
    filtersSheet: "Filters",
    defaultImage: "/images/product.jpg",
    appName: "ICS PC NorAm Surfactants Selection Tool",
    init() {
        if (this.initialized) return;
        
        this.wsHost = this.getElementValue("wshost", this.wsHost);
        this.excelId = this.getElementValue("excel-id", this.excelId);
        this.productsSheet = this.getElementValue("products-sheet", this.productsSheet);
        this.filtersSheet = this.getElementValue("filters-sheet", this.filtersSheet);
        this.defaultImage = this.getElementValue("default-image", this.defaultImage);
        this.appName = this.getElementValue("app-name", this.appName);
        this.initialized = true;
    },
    getElementValue(id, defaultValue) {
        var el = document.getElementById(id);
        if (el) return el.value || defaultValue;
        else return defaultValue;
    }
}